import { render, staticRenderFns } from "./NDI.vue?vue&type=template&id=d33098e0&scoped=true&"
import script from "./NDI.vue?vue&type=script&lang=ts&"
export * from "./NDI.vue?vue&type=script&lang=ts&"
import style0 from "./NDI.vue?vue&type=style&index=0&id=d33098e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33098e0",
  null
  
)

export default component.exports